import { Component, OnInit, OnDestroy } from '@angular/core';
import { SearchService } from '../../services/search.service';
import { SearchContext } from '../../models/search-request.interface';
import { ResultItem } from '../../models/search-response.interface';
import { Subscription } from 'rxjs';
import { FragmentService } from '../../services/fragment.service';
import { MetaService } from '../../services/meta.service';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  standalone: false,
})
export class SearchResultsComponent extends BaseComponent implements OnInit, OnDestroy {
  resultsCount = 0;
  searchResultResponse: ResultItem[] = [];
  suggestedWord: string | null = null;
  currentQuery = '';
  isLoading = false;
  private allResultsSub: Subscription;

  constructor(
    private searchService: SearchService,
    public fragmentService: FragmentService,
    public metaService: MetaService
  ) {
    super(fragmentService, metaService);
  }

  ngOnInit() {
    this.searchService.setParams({ query: '' });
    this.searchResultResponse = [];
    this.resultsCount = 0;
    this.suggestedWord = null;
    this.currentQuery = '';
    this.allResultsSub = this.searchService.allResults$.subscribe((data) => {
      this.searchResultResponse = data.results;
      this.resultsCount = data.results.length;
      this.suggestedWord = data.suggestedWord;
      this.currentQuery = data.currentQuery;
      this.isLoading = data.isLoading || false;
    });
  }

  applyCorrection(value: string) {
    localStorage.removeItem('allResultsSearchParams');
    this.searchService.setParams({ query: value, pageNo: 1 }, SearchContext.Results);
    this.isLoading = true;
  }

  ngOnDestroy() {
    if (this.allResultsSub) this.allResultsSub.unsubscribe();
  }
}
